import { connect } from 'react-redux';
import noop from 'lodash/noop';
import {
  isForecastView,
  canEditForecast,
  isKnockoutMatchEditable,
} from '@selectors/matches';
import { isSnapshotView } from '@selectors/location';
import { hasBothTeams } from '@utils/match';

import BracketMatchMobile from './BracketMatchMobile';

export const mapStateToProps = (state, match) => {
  let editable =
    !isSnapshotView(state) &&
    isForecastView(state) &&
    canEditForecast(state) &&
    isKnockoutMatchEditable(state, match);

  return {
    teams: noop(),
    canEditTeams: false,
    canEditScore: editable && hasBothTeams(match),
    hasBothTeams: hasBothTeams(match),
  };
};

export const mapDispatchToProps = (dispatch, { mid }) => ({
  onChange: (payload) =>
    dispatch({
      type: 'FORECAST_MATCHES_MATCH_SET',
      meta: { mid },
      payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BracketMatchMobile);
